import { FormControl, InputLabel, MenuItem } from '@mui/material'
import React from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { Button, ErrorForm, InputForm, InputSelect } from '../../components'
import { AuthContext, AuthContextType } from '../../contexts/authContext'
import { useYupValidation } from '../../hooks'
import { IShowApartments, IRequestMaintenances } from '../../interfaces'
import { errorHandler, PageService, ProfileService } from '../../services'
import { phoneMask } from '../../utils'
import { maintenancesSchema } from '../../yup'

export default function Maintenances(): React.ReactElement {
    const [isLoading, setIsLoading] = React.useState(false)
    const [apartments, setApartments] = React.useState<IShowApartments[] | []>([])
    const { setDataUser, getUserInfo } = React.useContext(AuthContext) as AuthContextType

    const navigate = useNavigate()
    const user = getUserInfo()

    async function init(): Promise<void> {
        const dataApartments: IShowApartments[] = await PageService.getShowApartments()
        setApartments(dataApartments)
        const profileContext = await ProfileService.getDataUser()
        setDataUser(profileContext)
    }

    React.useEffect(() => {
        init()
    }, [])

    const {
        handleSubmit,
        control,
        formState: { errors },
    } = useForm<IRequestMaintenances>({
        resolver: useYupValidation(maintenancesSchema),
    })

    async function requestApartments(values: IRequestMaintenances): Promise<void> {
        setIsLoading(true)
        try {
            const response = await PageService.postMaintenances(values)
            toast(response.message, { type: 'success' })
            navigate('/')
        } catch (err) {
            toast(errorHandler(err).message, { type: 'error' })
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <div className="card min-height">
            <div className="maintenances">
                <div className="box_form">
                    <div className="box_text">
                        <h4>Solicitação de Manutenção</h4>
                        <div className="box_description">
                            <p>Preencha os campos abaixo para solicitar manutenção na sua unidade.</p>
                            <p>Dúvidas? Entre em contato com +55 (47) 3393.6394</p>
                        </div>
                    </div>
                    <form className="keeping__inputs" onSubmit={handleSubmit(requestApartments)}>
                        <Controller
                            name="realEstateApartmentId"
                            control={control}
                            render={({ field: { value, onChange } }) => {
                                return (
                                    <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label">Apartamento</InputLabel>
                                        <InputSelect
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            label="Apartamento"
                                            placeholder="Apartamento"
                                            name="realEstateApartmentId"
                                            value={value}
                                            onChange={onChange}
                                            defaultValue=""
                                        >
                                            {apartments.map((apartment) => {
                                                return (
                                                    <MenuItem key={apartment.id} value={apartment.id}>
                                                        {apartment.description}
                                                    </MenuItem>
                                                )
                                            })}
                                        </InputSelect>
                                    </FormControl>
                                )
                            }}
                        />
                        <ErrorForm error={errors.realEstateApartmentId?.message} />
                        <Controller
                            name="email"
                            defaultValue={user?.email || ''}
                            control={control}
                            render={({ field: { value, onChange } }) => {
                                return <InputForm label="E-mail" placeholder="E-mail" name="email" value={value} onChange={onChange} />
                            }}
                        />
                        <ErrorForm error={errors.email?.message} />
                        <Controller
                            name="phone"
                            defaultValue={''}
                            control={control}
                            render={({ field: { value, onChange } }) => {
                                return (
                                    <InputForm
                                        label="Telefone"
                                        placeholder="Telefone"
                                        name="phone"
                                        value={phoneMask(value)}
                                        onChange={onChange}
                                        defaultValue=""
                                        inputProps={{
                                            minLength: 14,
                                            maxLength: 15,
                                        }}
                                    />
                                )
                            }}
                        />
                        <ErrorForm error={errors.phone?.message} />
                        <Controller
                            name="request"
                            defaultValue={''}
                            control={control}
                            render={({ field: { value, onChange } }) => {
                                return (
                                    <InputForm
                                        label="Sua solicitação"
                                        placeholder="Sua solicitação"
                                        name="request"
                                        value={value}
                                        onChange={onChange}
                                        defaultValue=""
                                        multiline
                                        rows={8}
                                        inputProps={{
                                            maxLength: 400,
                                        }}
                                    />
                                )
                            }}
                        />
                        <ErrorForm error={errors.request?.message} />
                        <div className="resquest_reply">
                            <p>O prazo de resposta para a solicitação é de 72 horas.</p>
                        </div>
                        <div className="box-button-maintenances">
                            <Button type={'button'} placeholder="Cancelar" onClick={() => navigate('/')} />
                            <Button isLoading={isLoading} type={'submit'} placeholder="Enviar" />
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}
